import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  openAll() {
    this.itemTargets.forEach((item) => {
      item.setAttribute("open", "open")
    })
  }

  collapseAll() {
    this.itemTargets.forEach((item) => {
      item.removeAttribute("open")
    })
  }
}
